import { yupResolver } from '@hookform/resolvers/yup/dist/yup';
import { Grid } from '@mui/material';
import React from 'react';
import { useForm } from 'react-hook-form';
import { validationsMessages } from '../../../lib';
import { AutocompleteChainSelector } from '../../autocomplete-chain-selector';
import {
    chainSelectorDefaults,
    ChainSelectorInputs,
    ChainSelectorSchema,
} from '../../chain-selector-modal/chain-selector-modal-helper';
import { chainSelectorStyle } from '../../chain-selector/chain-selector-helper';
import { styles } from '../landing-page-wrapper-helper';
import { TabItemsType, TabsComponent } from './TabComponent';

interface TabsAndSelectFieldComponentProps {
    selectedTab: any;
    onTabChange: (event: React.SyntheticEvent, newValue: any) => void;
    tabItems: TabItemsType[];
    tabsContainerStyles?: any;
    tabsStyles?: any;
    tabItemStyles?: any;
    isSelectFieldEnabled?: boolean;
    selectedChain?: string;
    setSelectedChain?: React.Dispatch<React.SetStateAction<any>>;
}

export const TabsAndSelectFieldComponent = ({
    selectedTab,
    tabItems,
    onTabChange,
    tabsContainerStyles,
    tabsStyles,
    tabItemStyles,
    isSelectFieldEnabled = false,
    selectedChain,
    setSelectedChain,
}: TabsAndSelectFieldComponentProps): React.JSX.Element | null => {
    const { control } = useForm<ChainSelectorInputs>({
        mode: 'all',
        resolver: yupResolver(ChainSelectorSchema),
        defaultValues: chainSelectorDefaults,
    });

    const onAutocompleteChange = (__: any, value: string): void => {
        setSelectedChain?.(value);
    };

    return (
        <Grid sx={{ ...styles.tabsContainer, ...tabsContainerStyles }}>
            <TabsComponent
                selectedTab={selectedTab}
                onTabChange={onTabChange || ((): void => {})}
                tabItems={tabItems}
                tabsStyles={tabsStyles}
                tabItemStyles={tabItemStyles}
            />
            {isSelectFieldEnabled && (
                <Grid>
                    <AutocompleteChainSelector
                        controlName='chain'
                        tooltipTitle={selectedChain ?? ''}
                        selectedChain={selectedChain}
                        control={control}
                        error={!selectedChain}
                        errorText={
                            !selectedChain ? validationsMessages.required : ''
                        }
                        handleOnChange={onAutocompleteChange}
                        autocompleteStyles={
                            chainSelectorStyle.chainAutocomplete
                        }
                    />
                </Grid>
            )}
        </Grid>
    );
};
